import gql from 'graphql-tag';

export const ALLROLES = gql`
  query allRoles{
    rols{
      id
      nombre
    }
  }
`;

export const ROL = gql`
  query getRol($id: Int!) {
    rol(id: $id) {
      id
      nombre
      permisos {
        id
        nombre
      }
    }
  }
`;

export const EDITROL = gql`
  mutation editRol($id:Int!, $nombre:String!, $permisos:[Int]){
    updateRol(id:$id, rol:{
      nombre:$nombre
      permisos:$permisos
    }){
      id
    }
  }
`;

export const NEWROL = gql`
  mutation newRol($nombre:String!, $permisos:[Int]){
    addRol(rol:{
      nombre:$nombre
      permisos:$permisos
    }){
      id
    }
  }
`;

export const ALLPERMISOS = gql`
  query allPermisos{
    permisos{
      id
      nombre
    }
  }
`;
